import { useTranslation } from "react-i18next";

export default function ValueSection() {
  const { t } = useTranslation();

  const items = [
    {
      icon: "ri-links-line",
      titleKey: "value_item1_title",
      textKey: "value_item1_text",
    },
    {
      icon: "ri-discuss-line",
      titleKey: "value_item2_title",
      textKey: "value_item2_text",
    },
    {
      icon: "ri-lightbulb-line",
      titleKey: "value_item3_title",
      textKey: "value_item3_text",
    },
    {
      icon: "ri-briefcase-line",
      titleKey: "value_item4_title",
      textKey: "value_item4_text",
    },
  ];

  return (
    <section className="w-full bg-[#1a1a1a] py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-[#BF9B5E] text-xs font-semibold tracking-[0.3em] uppercase mb-4">
            {t("value_label")}
          </p>
          <h2 className="text-white text-3xl md:text-5xl font-bold leading-tight">
            {t("value_title")}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {items.map((item) => (
            <div
              key={item.titleKey}
              className="border border-white/10 p-8 hover:border-[#BF9B5E] transition-colors duration-300 group"
            >
              <div className="w-10 h-10 flex items-center justify-center mb-6">
                <i className={`${item.icon} text-[#BF9B5E] text-2xl`} />
              </div>
              <h3 className="text-white text-lg font-semibold mb-3 group-hover:text-[#BF9B5E] transition-colors">
                {t(item.titleKey)}
              </h3>
              <p className="text-white/60 text-sm leading-relaxed">
                {t(item.textKey)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
